'use strict';

$(document).on('change', 'select.js-brand-tech', function () {
    var id = $(this).val();

    $('select.js-brand-details > :not(:first)').remove();
    $('select.js-brand-details').trigger('refresh');

    if (id < 1) {
        return;
    }

    $.post('/brands/tech/details/', {brand_id: window.BRAND_ID, tech_id: id}, function (response) {
        if (!response.items) {
            $('.js-detail-go').attr('disabled', true).addClass('disabled');
            return;
        }

        var options = response.items
            .map(function (brand) {
                return '<option value="' + brand.id + '" data-url="' + brand.url + '">' + brand.name + '</option>';
            })
            .join('');

        $('select.js-brand-details').append(options).trigger('refresh');
    });
});

$(document).on('change', 'select.js-brand-details', function () {
    var value = $(this).val();
    $('.js-detail-go').attr('disabled', !value)[value ? 'removeClass' : 'addClass']('disabled');
});

$('.js-detail-go').click(function () {
    var url = $('select.js-brand-details > :selected').data('url');

    if (!url) {
        return;
    }

    window.location = url;
});
